<template>
    <div class="row">
        <div class="col-sm-12">
            <form @submit.prevent="validateBeforeSubmit">
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="faq_id">ID</label>
                        <div class="col-sm-7">
                            <input :class="{'form-control':true }" :disabled="isEdit"
                                   id="faq_id" maxlength="20" name="faq_id" type="text"
                                   v-model="form.id" v-validate="'required|max:20'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('faq_id')"/>
                                <span v-show="errors.has('faq_id')">{{ errors.first('faq_id') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="faq_category">Categoría</label>
                        <div class="col-sm-7">
                            <input :class="{'form-control':true }" id="faq_category" maxlength="100"
                                   name="faq_category" type="text"
                                   v-model="form.category" v-validate="'required|max:100'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('faq_category')"/>
                                <span v-show="errors.has('faq_category')">{{ errors.first('faq_category') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="faq_subcategory">Subcategoría</label>
                        <div class="col-sm-7">
                            <input :class="{'form-control':true }" id="faq_subcategory" maxlength="100"
                                   name="faq_subcategory" type="text"
                                   v-model="form.subcategory" v-validate="'required|max:100'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('faq_subcategory')"/>
                                <span v-show="errors.has('faq_subcategory')">{{ errors.first('faq_subcategory') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="faq_question">Pregunta</label>
                        <div class="col-sm-7">
                            <input :class="{'form-control':true }" id="faq_question"
                                   name="faq_question" type="text"
                                   v-model="form.question" v-validate="'required'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('faq_question')"/>
                                <span v-show="errors.has('faq_question')">{{ errors.first('faq_question') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label class="col-sm-2 col-form-label">Variantes</label>
                        <div class="col-sm-7">
                            <div :key="'variant-'+index" class="input-group mb-2"
                                 v-for="(variant, index) in form.variants">
                                <label :for="'faq_variant_'+index" class="sr-only">Variante {{ index + 1 }}</label>
                                <input :id="'faq_variant_'+index" :value="variant" class="form-control" type="text"
                                       @input="form.variants.splice(index, 1, $event.target.value)">
                                <div class="input-group-append">
                                    <button :disabled="form.variants.length <= 1" class="btn btn-outline-danger"
                                            type="button" @click="removeVariant(index)">
                                        <font-awesome-icon :icon="['fas', 'trash']"/>
                                    </button>
                                </div>
                            </div>
                            <button class="btn btn-outline-primary btn-sm" type="button" @click="addVariant">
                                <font-awesome-icon :icon="['fas', 'plus']"/>
                                Agregar variante
                            </button>
                        </div>
                    </div>

                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="faq_answer">Respuesta</label>
                        <div class="col-sm-7">
                            <textarea :class="{'form-control':true }" id="faq_answer"
                                      name="faq_answer" rows="5"
                                      v-model="form.answer" v-validate="'required'"></textarea>
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('faq_answer')"/>
                                <span v-show="errors.has('faq_answer')">{{ errors.first('faq_answer') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <label class="col-sm-2 col-form-label">Keywords</label>
                        <div class="col-sm-7">
                            <div :key="'keyword-'+index" class="input-group mb-2"
                                 v-for="(keyword, index) in form.keywords">
                                <label :for="'faq_keyword_'+index" class="sr-only">Keyword {{ index + 1 }}</label>
                                <input :id="'faq_keyword_'+index" :value="keyword" class="form-control" type="text"
                                       @input="form.keywords.splice(index, 1, $event.target.value)">
                                <div class="input-group-append">
                                    <button :disabled="form.keywords.length <= 1" class="btn btn-outline-danger"
                                            type="button" @click="removeKeyword(index)">
                                        <font-awesome-icon :icon="['fas', 'trash']"/>
                                    </button>
                                </div>
                            </div>
                            <button class="btn btn-outline-primary btn-sm" type="button" @click="addKeyword">
                                <font-awesome-icon :icon="['fas', 'plus']"/>
                                Agregar keyword
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-sm-6">
            <div slot="footer">
                <img src="/images/loading.svg" v-if="loading" width="40px"/>
                <button @click="validateBeforeSubmit" class="btn btn-success" type="submit" v-if="!loading">
                    <font-awesome-icon :icon="['fas', 'dot-circle']"/>
                    {{ $t('global.buttons.submit') }}
                </button>
                <router-link :to="{ name: 'FaqsEmbeddingList' }" v-if="!loading">
                    <button class="btn btn-danger" type="reset">
                        {{ $t('global.buttons.cancel') }}
                    </button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { API } from './../../api'

    export default {
        data: () => {
            return {
                loading: false,
                isEdit: false,
                form: {
                    id: '',
                    category: '',
                    subcategory: '',
                    question: '',
                    variants: [''],
                    answer: '',
                    keywords: ['']
                }
            }
        },
        mounted: function () {
            if (this.$route.params.id !== undefined) {
                this.isEdit = true
                this.loading = true
                API.get('faqs_embedding/' + this.$route.params.id).then((result) => {
                    this.loading = false
                    let faq = result.data.data
                    this.form = {
                        id: faq.id,
                        category: faq.category,
                        subcategory: faq.subcategory,
                        question: faq.question,
                        variants: (faq.variants && faq.variants.length > 0) ? faq.variants.slice() : [''],
                        answer: faq.answer,
                        keywords: (faq.keywords && faq.keywords.length > 0) ? faq.keywords.slice() : ['']
                    }
                }).catch((error) => {
                    this.loading = false
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'FAQs (IA)',
                        text: (error.response && error.response.data && error.response.data.error)
                            ? error.response.data.error.message
                            : this.$t('inclusions.error.messages.connection_error')
                    })
                })
            }
        },
        methods: {
            addVariant () {
                this.form.variants.push('')
            },
            removeVariant (index) {
                this.form.variants.splice(index, 1)
            },
            addKeyword () {
                this.form.keywords.push('')
            },
            removeKeyword (index) {
                this.form.keywords.splice(index, 1)
            },
            validateBeforeSubmit () {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'FAQs (IA)',
                            text: this.$t('inclusions.error.messages.information_complete')
                        })
                        return
                    }

                    let variants = this.form.variants.map(v => v.trim()).filter(v => v !== '')
                    let keywords = this.form.keywords.map(k => k.trim()).filter(k => k !== '')

                    if (variants.length === 0) {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'FAQs (IA)',
                            text: 'Debe ingresar al menos una variante'
                        })
                        return
                    }

                    if (keywords.length === 0) {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'FAQs (IA)',
                            text: 'Debe ingresar al menos un keyword'
                        })
                        return
                    }

                    this.submit(variants, keywords)
                })
            },
            submit (variants, keywords) {
                this.loading = true

                let payload = {
                    category: this.form.category,
                    subcategory: this.form.subcategory,
                    question: this.form.question,
                    variants: variants,
                    answer: this.form.answer,
                    keywords: keywords
                }

                if (!this.isEdit) {
                    payload.id = this.form.id
                }

                API({
                    method: this.isEdit ? 'patch' : 'post',
                    url: 'faqs_embedding/' + (this.isEdit ? this.form.id : ''),
                    data: payload
                }).then(() => {
                    this.$router.push({ name: 'FaqsEmbeddingList' })
                }).catch((error) => {
                    this.loading = false
                    let message = this.$t('inclusions.error.messages.connection_error')
                    if (error.response && error.response.data && error.response.data.error) {
                        let apiError = error.response.data.error
                        message = apiError.message
                        if (apiError.details && apiError.details.length > 0) {
                            message += ': ' + apiError.details.map(d => d.message).join(', ')
                        }
                    }
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'FAQs (IA)',
                        text: message
                    })
                })
            }
        }
    }
</script>
